import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AppointmentActivityButton,
  AppointmentActivityIcons,
  AppointmentActivityInnerWrapper,
  AppointmentActivityTexts,
  AppointmentMenuButton,
  ButtonWrapper,
} from './style'

interface IProps {
  setSelectViewOpen: (viewSwitch: 'activity' | 'menu') => void
}

export const ButtonContainer: FunctionComponent<IProps> = ({
  setSelectViewOpen,
}) => {
  const { t } = useTranslation()

  return (
    <ButtonWrapper>
      <AppointmentMenuButton onClick={() => setSelectViewOpen('menu')}>
        <AppointmentActivityInnerWrapper>
          <AppointmentActivityIcons icon="plus-circle" />
          <AppointmentActivityTexts>{t('Menu')}</AppointmentActivityTexts>
        </AppointmentActivityInnerWrapper>
      </AppointmentMenuButton>
      <AppointmentActivityButton
        type="button"
        onClick={() => setSelectViewOpen('activity')}
      >
        <AppointmentActivityInnerWrapper>
          <AppointmentActivityIcons icon="plus-circle" />
          <AppointmentActivityTexts>{t('Activity')}</AppointmentActivityTexts>
        </AppointmentActivityInnerWrapper>
      </AppointmentActivityButton>
    </ButtonWrapper>
  )
}
